<template>
  <div class="cmp-manual_match_modal-top ut-flex ut-alstart">
    <div style="flex: 1" class="left-side">
      <div class="ut-flex left-top-h side--subtitle">
        <div class="side--subtitle-text">{{ $t("import") }}</div>
        <div class="dt-icon-container">
          <img
            src="static/icons/help-gray.svg"
            class="dt-icon v5 s2 ut-center"
            :title="$t('manual_match_import_hint')"
            :alt="$t('manual_match_import_hint')"
          />
        </div>
      </div>
      <TextField
        class="mb10"
        :id="'import_artist'"
        v-bind="textFieldConfig"
        :value="statementLine.import_artist || ''"
        disabled
        :placeholder="$t('artist')"
        @valuechanged="onTextFieldValueChange"
        :searchLinkText="$t('search_in_catalog')"
        :searchIcon="'search-blue'"
        @searchClick="onSearchClick"
      />
      <TextField
        class="mb10"
        :id="'import_title'"
        v-bind="textFieldConfig"
        :value="statementLine.import_title || ''"
        disabled
        :placeholder="$t('title')"
        @valuechanged="onTextFieldValueChange"
        :searchIcon="'search-blue'"
        :searchLinkText="$t('search_in_catalog')"
        @searchClick="onSearchClick"
      />

      <TextField
        class="mb10"
        :id="'identifier'"
        v-bind="textFieldConfig"
        :value="statementLine.identifier || ''"
        disabled
        :placeholder="$t('identifier')"
        @valuechanged="onTextFieldValueChange"
        :searchIcon="'search-blue'"
        :searchLinkText="$t('search_in_catalog')"
        @searchClick="onSearchClick"
      />
      <TextField
        class="mb10"
        :id="'cost_description'"
        v-bind="textFieldConfig"
        :value="statementLine.cost_description || ''"
        disabled
        :placeholder="$t('description')"
      />
      <TextField
        class="mb10"
        :id="'import_cat_no'"
        v-bind="textFieldConfig"
        :value="statementLine.import_cat_no || ''"
        disabled
        :placeholder="$t('catalog_no')"
        @valuechanged="onTextFieldValueChange"
        @searchClick="onSearchClick"
      />
      <TextField
        v-if="currentChannel == 'physical'"
        class="mb10"
        :id="'import_format'"
        v-bind="textFieldConfig"
        :value="statementLine.import_format || ''"
        disabled
        :placeholder="$t('format')"
        @valuechanged="onTextFieldValueChange"
        @searchClick="onSearchClick"
      />
      <TextField
        v-if="cost_group_target"
        class="mb10"
        :id="'cost_group_target'"
        v-bind="textFieldConfig"
        :value="cost_group_target || ''"
        disabled
        :placeholder="$t('cost_group')"
        @valuechanged="onTextFieldValueChange"
      />
      <TextField
        class="mb10"
        :id="'ppu'"
        v-bind="textFieldConfig"
        :value="ppu || ''"
        disabled
        :placeholder="$t('Price')"
        @valuechanged="onTextFieldValueChange"
      />
    </div>
    <div class="middle-divider">
      <div class="top-part"></div>
      <div class="dt-icon-container">
        <img
          src="static/icons/arrows/arrow-right.svg"
          class="dt-icon v5 s2 ut-center"
          alt
        />
      </div>
      <div class="bottom-part"></div>
    </div>
    <div style="flex: 1" class="right-side">
      <div class="ut-flex right-top-h side--subtitle">
        <div class="side--subtitle-text">
          {{ $t("relate_to_choose_data_from_cat") }}
        </div>
        <div class="dt-icon-container">
          <img
            src="static/icons/help-gray.svg"
            class="dt-icon v5 s2 ut-center"
            :title="$t('manual_match_relate_to_hint')"
            :alt="$t('manual_match_relate_to_hint')"
          />
        </div>
      </div>
      <TextField
        class="mb10"
        :id="'import_artist'"
        v-bind="textFieldConfig"
        :value="selectedData.artist || ''"
        disabled
        :placeholder="$t('artist')"
        @valuechanged="onTextFieldValueChange"
      />
      <TextField
        class="mb10"
        :id="'import_title'"
        v-bind="textFieldConfig"
        :value="selectedData.title || ''"
        disabled
        :placeholder="$t('title')"
        @valuechanged="onTextFieldValueChange"
      />
      <TextField
        class="mb10"
        :id="'version'"
        v-if="currentChannel === 'physical' || currentChannel === 'digital'"
        v-bind="textFieldConfig"
        :value="selectedData.version || ''"
        disabled
        :placeholder="$t('version')"
        @valuechanged="onTextFieldValueChange"
      />
      <TextField
        class="mb10"
        :id="'identifier'"
        v-bind="textFieldConfig"
        :value="selectedData.isrc || ''"
        disabled
        :placeholder="$t('identifier')"
        @valuechanged="onTextFieldValueChange"
      />
      <TextField
        class="mb10"
        :id="'import_cat_no'"
        v-bind="textFieldConfig"
        :value="selectedData.catalog_no || ''"
        disabled
        :placeholder="$t('catalog_no')"
        @valuechanged="onTextFieldValueChange"
      />
      <div style="height: 90px"></div>
    </div>
  </div>
</template>

<script>
import Modal from "../../../../dt-plugins/modal/modal";

import { DTIconButton } from "../../../../plugins/button/button";
import NTable from "../../../../plugins/datatable/datatable";

import InputField from "@plugins/text-field/input-field";

import ModalContainer from "@dtplugins/modal/modal-container";
import { DistributionStatementService } from "../../services/statement.service";

export default {
  props: {
    modalData: {
      type: Object,
    },
  },
  components: {
    Modal,
    NTable,
    InputField,
    DTIconButton,
    ModalContainer,

    //AdvanceSearch,
  },
  mounted: async function () {},
  data: function () {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
      },
    };
  },
  mixins: [],

  computed: {
    statement_line_id: function () {
      return this.$route?.query?.statement_line_id || "";
    },

    statementLine: function () {
      return this.modalData?.stmt_line || {};
    },
    currentChannel: function () {
      return this.$route?.query?.channel || "";
    },
    ppu: function () {
      return this.modalData?.stmt_line?.ppu || "";
    },
    cost_group_target: function () {
      return this.modalData?.cost_group?.target || null;
    },

    selectedData: function () {
      return this.modalData?.selectedData || {};
    },
  },
  methods: {
    onCancelClick: function () {
      this.$emit("cancelled", true);
    },
    onSearchClick: function (payload) {
      this.$emit("search", payload);
    },
    onTextFieldValueChange: function (name, value) {},
  },
};
</script>

<style lang="scss">
.cmp-manual_match_modal-top {
  .left-side {
    .dt-input-box {
      background-color: var(--bittersweet-a10) !important;
    }
    //
  }
  .middle-divider {
    min-width: 56px;
    height: 286px;
    margin-top: 32px;
    margin-bottom: 10px;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .top-part,
    .bottom-part {
      height: 100%;
      width: 1px;
      background-color: var(--bc-8);
      flex: 1;
    }

    .dt-icon-container {
      max-height: 30px;
    }
  }
  .right-side {
    .dt-input-box {
      background-color: var(--emerald-a10) !important;
    }
    //
  }
  .right-side,
  .left-side {
    .side--subtitle,
    .side--subtitle {
      color: var(--text-secondary);
      margin-bottom: 5px;
      display: flex;
      .side--subtitle-text {
        flex: 1;
      }
    }
    .dt-input-box {
      border: 1px solid var(--sprt-5) !important;
    }
  }

  .dt-input-box {
    .input-container {
      width: calc(100% - 150px) !important;

      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      input {
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    // background: red;
    .search-label {
      // background: red;
      min-width: 150px !important;
    }
  }
}

// }
</style>